import { render, staticRenderFns } from "./DriverSearch.vue?vue&type=template&id=47c8459c&"
import script from "./DriverSearch.vue?vue&type=script&lang=js&"
export * from "./DriverSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports